import React, { useState, useEffect, useMemo } from "react";
import cn from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { withRouter, useLocation, Link } from "react-router-dom";
import { format } from "date-fns";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "./style.scss";
import Card from "./card";
import { FETCH_GROUP_ORDER_DASHBOARD } from "../../store/GroupOrder/GroupOrder.constant";
import AnimatedLoader from "../../modules/ui/animatedLoader";
import ModalAuth from "../../modules/ui/Modals/ModalAuth";
import ModalConfirmation from "../../modules/ui/Modals/ModalСonfirmation";
import {
  CLOSE_MODAL_AUTH,
  MODAL_TOGGLE,
  NEW_USER_MODAL,
} from "../../store/Modal/Modal.constant";
import { WidgetFooter, WidgetHeader } from "../../widgets";
import ModalEditProfile from "../../modules/ui/Modals/ModalEditProfile";
import { GROUP_ORDER_ADMIN_DASHBOARD_AUTH } from "../../store/Form/Form.constant";
import ModalSetting from "../../modules/ui/Modals/ModalSetting";
import ModalGroupSetting from "../../modules/ui/Modals/ModalGroupSettings";
import { getGroupsOfGroupOrderApi } from "../../shared/services/Api/Report";
import OrderInformation from "../../modules/ui/OrderInformation";
import "../Home/style.scss";
import "../Home/Invitation/style.scss";
import "../Home/TopTabs/style.scss";
import "../Home/MyOrder/style.scss";

const GroupOrder = ({ match }) => {
  const location = useLocation();
  const { slug_uuid } = match?.params || {};
  const token = localStorage.getItem("token");

  const dispatch = useDispatch();
  const { groupOrderData, isLoading } = useSelector(
    (state) => state.groupOrderDashboard
  );
  const company_name =
    (Array.isArray(groupOrderData) &&
      groupOrderData[0]?.creator_company_name) ||
    "";
  const joinedGrupOrders = "joined_group_orders";
  const upcomingGroupOrders = "active";
  const yetToJoinGroupOrders = "yet_to_join_group_orders";
  const pastGroupOrders = "past_group_orders";
  const [selectedFilters, setSelectedFilters] = useState(
    localStorage.getItem("selectedFilter") || upcomingGroupOrders
  );
  const common = useSelector((state) => state.common);
  const settings = common.settings?.[slug_uuid];
  const form = useSelector((state) => state.form);
  const modals = useSelector((store) => store.modal[slug_uuid]);
  const groupOrders = common.groupOrders?.[slug_uuid];
  const { search, state } = useLocation();
  const query = new URLSearchParams(search);
  const adminToken = query.get('token'); // Replace 'myParam' with your key
  const [groupData, setGroupsData] = useState([]);

  const handleFilterChange = (event) => {
    const { value } = event.target;
    localStorage.setItem("selectedFilter", value);
    setSelectedFilters(value);
  };
  useEffect(() => {
    const key = localStorage.getItem("GroupOrderMemberID");
    const GroupOrderMemberID = key == "undefined" ? null : JSON.parse(key);
    if (typeof GroupOrderMemberID !== "number") {
      localStorage.setItem("GroupOrderMemberID", null);
    }
  }, []);
  useEffect(() => {
    if (adminToken) {
      dispatch({ type: GROUP_ORDER_ADMIN_DASHBOARD_AUTH, payload: { user_id: slug_uuid, token: adminToken } });
    }
  }, [slug_uuid, adminToken]);
  const fetchData = async () => {
    const token = await localStorage.getItem("token");
    if (token) {
      dispatch({
        type: FETCH_GROUP_ORDER_DASHBOARD,
        payload: { id: slug_uuid, filter: selectedFilters },
      });
    }
  };
  useEffect(() => {
    if (settings?.auth?.auth_token !== token) {
      dispatch({ type: NEW_USER_MODAL, payload: slug_uuid });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedFilters, token, location]);

  const activeJoinedOrder = useMemo(() => {
    if (!Array.isArray(groupOrderData)) return null;
    return groupOrderData.find(
      (item) =>
        item.joined &&
        item.status !== "waiting_for_delivery" &&
        item.status !== "delivered" &&
        item.order_deadline
    );
  }, [groupOrderData]);

  const selectedFilterLable = useMemo(() => {
    switch (selectedFilters) {
      case upcomingGroupOrders:
        return "Upcoming Corporate Orders";
      case yetToJoinGroupOrders:
        return "Yet To Join Corporate Orders";
      case joinedGrupOrders:
        return "Joined Corporate Orders";
      case pastGroupOrders:
        return "Past Corporate Orders";
      default:
        return "";
    }
  }, [selectedFilters]);
  const fetchGroups = async () => {
    try {
      const response = await getGroupsOfGroupOrderApi({ user_id: slug_uuid });
      if (response) {
        setGroupsData(response);
      }
    } catch (error) {
      console.error("Failed to fetch groups", error);
    }
  };
  useEffect(() => {
    if (slug_uuid) {
      fetchGroups();
    }
  }, [slug_uuid])
  return (
    <>
      <AnimatedLoader isLoading={isLoading} />
      <WidgetHeader user_id={slug_uuid} isJoin={true} auth={settings?.auth} />
      {!adminToken && modals?.isModalAuth ? (
        <ModalAuth
          user_id={slug_uuid}
          error={form.form?.error?.message}
          show={modals.isModalAuth}
          onHide={() =>
            dispatch({ type: CLOSE_MODAL_AUTH, payload: slug_uuid })
          }
        />
      ) : null}
      {!adminToken && modals?.isModalConfirmation ? (
        <ModalConfirmation
          user_id={slug_uuid}
          isResendCode={settings?.isResendCode}
          error={form.form?.error?.message}
          show={modals.isModalConfirmation}
          order_deadline={groupOrders?.order_deadline * 1000}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalConfirmation", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalEditProfile ? (
        <ModalEditProfile
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalEditProfile}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalEditProfile", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalSetting ? (
        <ModalSetting
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalSetting}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalSetting", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalGroupSetting ? (
        <ModalGroupSetting
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalGroupSetting}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalGroupSetting", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      <div className="banner">
        <img src="/img/banner.webp" alt="Colorful group catering spread with multiple dishes" />
        <span className="group-name">{company_name} Corporate Order DashBoard</span>

      </div>
      <div className="container px-0 group-order-container">
        {selectedFilters === upcomingGroupOrders && activeJoinedOrder ? (
          <div className="active-team-lunch-callout">
            <div className="active-team-lunch-callout__icon">✨</div>
            <div className="active-team-lunch-callout__body">
              <span className="active-team-lunch-callout__label">
                Active Team Lunch <span className="dot" />
              </span>
              <h4>
                {activeJoinedOrder.name} @ {activeJoinedOrder.restaurant_name}
              </h4>
              <p>
                Submit your meal choice before{" "}
                {format(
                  new Date(activeJoinedOrder.order_deadline * 1000),
                  "EEEE, MMMM do, h:mm a"
                )}
                .
              </p>
            </div>
            <Link
              to={`/group_order/${activeJoinedOrder.slug || activeJoinedOrder.id}?creator_id=${slug_uuid}`}
              className="active-team-lunch-callout__btn"
            >
              Open {activeJoinedOrder.name}
              <span aria-hidden="true">›</span>
            </Link>
          </div>
        ) : null}
        <div className="dashboard-filter-bar">
          <div className="dashboard-filter-bar__heading">
            <span className="dashboard-filter-bar__eyebrow">Corporate orders</span>
            <h3>{selectedFilterLable}</h3>
            <p>Choose a view to quickly find the orders you need.</p>
          </div>

          <div className="dashboard-filter-bar__options">
            <form className="form-flex">
              <div className="form-group">
                <input
                  type="checkbox"
                  id="filter-upcoming"
                  name="group-order-filter"
                  value={upcomingGroupOrders}
                  checked={selectedFilters === upcomingGroupOrders}
                  onChange={handleFilterChange}
                />
                <label htmlFor="filter-upcoming">Upcoming Corporate Orders</label>
              </div>
              <div className="form-group">
                <input
                  type="checkbox"
                  id="filter-joined"
                  name="group-order-filter"
                  value={joinedGrupOrders}
                  checked={selectedFilters === joinedGrupOrders}
                  onChange={handleFilterChange}
                />
                <label htmlFor="filter-joined">Joined Corporate Orders</label>
              </div>
              <div className="form-group">
                <input
                  type="checkbox"
                  id="filter-yet-to-join"
                  name="group-order-filter"
                  value={yetToJoinGroupOrders}
                  checked={selectedFilters === yetToJoinGroupOrders}
                  onChange={handleFilterChange}
                />
                <label htmlFor="filter-yet-to-join">Yet To Join Corporate Orders</label>
              </div>
              <div className="form-group">
                <input
                  type="checkbox"
                  id="filter-past"
                  name="group-order-filter"
                  value={pastGroupOrders}
                  checked={selectedFilters === pastGroupOrders}
                  onChange={handleFilterChange}
                />
                <label htmlFor="filter-past">Past Corporate Orders</label>
              </div>
            </form>
          </div>
        </div>
        {groupOrderData && groupOrderData.length > 0 ? (
          <div className="group-cards">
            {groupOrderData?.map((item) => (
              <Card is_dashboard_admin={settings?.auth?.is_dashboard_admin} groupData={groupData} slug_uuid={slug_uuid} key={item.id} {...item} />
            ))}
          </div>
        ) : (
          <h3
            style={{ height: "50vh", opacity: ".6" }}
            className="text-center opacity-3 d-flex justify-content-center align-items-center"
          >
            Oops! No corporate orders have been added here, yet
          </h3>
        )}
      </div>
    </>
  );
};

const BUDGET = 1.0;

const CATEGORIES = [
  "Breakfast - Sweet (Acai Bowls)",
  "new cate",
  "Breakfast - Sweet (Chia Pudd'n)",
  "Breakfast - Sweet (Stolen Oats)",
  "Breakfast - Savoury",
  "Bowls",
];

const INITIAL_ITEMS = [
  {
    id: 1,
    name: "Hold Up",
    tags: "Breakfast, Healthy, Bowls, Gluten-free, Dairy-free, Vegan",
    price: 0.5,
    img: "/img/orderimage2.png",
    category: "Breakfast - Sweet (Acai Bowls)",
    qty: 2,
  },
  {
    id: 2,
    name: "Key West",
    tags: "Breakfast, Healthy, Bowls, Gluten-free, Vegan, Dairy-free, Nut-free",
    price: 0.01,
    img: "/img/orderimage3.png",
    category: "Breakfast - Sweet (Acai Bowls)",
    qty: 4,
  },
  {
    id: 3,
    name: "Eco Bamboo Cutlery & Napkins Set",
    tags: "Eco-friendly, Cutlery",
    price: 0.0,
    img: "/img/orderimage1.png",
    category: "new cate",
    qty: 0,
  },
  {
    id: 4,
    name: "Pear Pressure",
    tags: "Breakfast, Healthy, Nut-free, Vegan, Dairy-free",
    price: 8.78,
    img: "/img/orderimage4.png",
    category: "Bowls",
    qty: 0,
  },
  {
    id: 5,
    name: "test two menu item",
    tags: "Asian, French, Allergy-Friendly, Vegan",
    price: 10.0,
    img: "/img/modalimage.png",
    category: "Breakfast - Savoury",
    qty: 0,
  },
  {
    id: 6,
    name: "Morning Sunrise Chia Pudd'n",
    tags: "Breakfast, Gluten-free, Vegan",
    price: 6.5,
    img: "/img/orderimage6.png",
    category: "Breakfast - Sweet (Chia Pudd'n)",
    qty: 0,
  },
  {
    id: 7,
    name: "Stolen Oats Overnight Bircher Bowl",
    tags: "Breakfast, Sweet, Raw Vegan",
    price: 7.25,
    img: "/img/orderimage5.png",
    category: "Breakfast - Sweet (Stolen Oats)",
    qty: 0,
  },
  {
    id: 8,
    name: "Green Goddess Glow Smoothie",
    tags: "Beverages, Detox, Vegan",
    price: 5.95,
    img: "/img/team-banner.jpg",
    category: "Bowls",
    qty: 0,
  },
];

const STATS = [
  {
    id: 1,
    iconSrc: "/img/top-up.png",
    iconBg: "#EEF1F4",
    title: "Top Up:",
    content: "$0.00",
  },
  {
    id: 2,
    iconSrc: "/img/floaticon1.svg",
    iconBg: "#E3F3E5",
    title: "Budget Left:",
    content: "$0.00",
  },
  {
    id: 3,
    iconSrc: "/img/floaticon2.svg",
    iconBg: "#FDEBD7",
    title: "Order must be submitted by:",
    content: "Thursday, September 17th, 2:27 PM",
  },
  {
    id: 4,
    iconSrc: "/img/floaticon3.svg",
    iconBg: "#FBE6E4",
    title: "Group:",
    content: "4 out of 12 joined",
  },
];

const SundayProductCard = ({ item, onAdd, onRemove }) => {
  return (
    <div className={cn("elem__order", "order1", { active__full: item.qty > 0 })}>
      <div className="order__image">
        <img src={item.img} alt={item.name} />
        <div
          className={cn("order__float", { active__order: item.qty > 0 })}
          onClick={() => (item.qty > 0 ? onRemove(item.id) : onAdd(item.id))}
        >
          <img src="/img/pathimage.svg" alt="path" />
        </div>
      </div>
      <div className="order__info">
        <h6>{item.name}</h6>
        <div className="order__list">
          <ul>
            <li className="spacer" />
            <li>{item.tags}</li>
          </ul>
        </div>
        <div className="order__price">
          <p>${item.price.toFixed(2)}</p>
          {item.qty > 0 ? (
            <div className="card-stepper">
              <button type="button" onClick={() => onRemove(item.id)}>
                −
              </button>
              <span>{item.qty}</span>
              <button type="button" onClick={() => onAdd(item.id)}>
                +
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="card-add-btn"
              onClick={() => onAdd(item.id)}
            >
              Add
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export const SundayTeamLunch = () => {
  const [items, setItems] = useState(INITIAL_ITEMS);
  const [mainTab, setMainTab] = useState("items");
  const [category, setCategory] = useState("all");
  const [showCheckout, setShowCheckout] = useState(false);

  const addItem = (id) =>
    setItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, qty: item.qty + 1 } : item
      )
    );
  const removeItem = (id) =>
    setItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, qty: Math.max(0, item.qty - 1) } : item
      )
    );
  const clearCart = () =>
    setItems((prev) => prev.map((item) => ({ ...item, qty: 0 })));

  const visibleItems = useMemo(
    () =>
      category === "all"
        ? items
        : items.filter((item) => item.category === category),
    [items, category]
  );
  const withinBudget = visibleItems.filter((item) => item.price <= BUDGET);
  const outsideBudget = visibleItems.filter((item) => item.price > BUDGET);

  const selectedItems = items.filter((item) => item.qty > 0);
  const itemCount = items.reduce((sum, item) => sum + item.qty, 0);
  const total = items.reduce((sum, item) => sum + item.qty * item.price, 0);
  const companyPortion = Math.min(BUDGET, total);
  const youPay = Math.max(0, total - companyPortion);

  const shareLink = () =>
    toast.success("Share link copied to clipboard", { autoClose: 2000 });
  const openCheckout = () => setShowCheckout(true);
  const confirmOrder = () => {
    clearCart();
    setShowCheckout(false);
    toast.success("Order submitted successfully", { autoClose: 2500 });
  };

  return (
    <div className="sunday-team-lunch-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sunday Team Lunch - Friday, September 18th, 2:27 pm</title>
      </Helmet>
      <WidgetHeader
        user_id="sunday-team-lunch"
        isJoin={true}
        auth={{ first_name: "mle", last_name: "e" }}
        creator_id="2254"
        cartCount={itemCount}
        onCartClick={openCheckout}
      />
      <div className="container back-to-dashboard-wrapper">
        <Link to="/sunday-team-lunch" className="back-to-dashboard-link">
          <span aria-hidden="true">←</span> Back to Corporate Orders Dashboard
        </Link>
        <span className="invited-by">Invited by Sarah Jenkins</span>
      </div>

      <div className="invitation__block">
        <div className="container">
          <div className="invitation__head">
            <div className="invitation__box">
              <div className="welcome__invitation">
                <span className="welcome__chip">
                  Garden Gangsters (Liberty Village) &nbsp;•&nbsp; Toronto
                </span>
              </div>
              <div className="invitation__desc">
                <span>Sunday Team Lunch</span>
                <p>
                  <span className="invitation__clock" aria-hidden="true">
                    🕐
                  </span>
                  Friday, September 18th, 2:27 pm
                </p>
              </div>
            </div>
            <a href="/sunday-team-lunch">
              <img src="/img/invitationlogo.svg" alt="invitation" />
            </a>
          </div>
          <div className="orders__info">
            <div className="orders__left">
              {STATS.map((order) => (
                <OrderInformation
                  key={order.id}
                  iconSrc={order.iconSrc}
                  iconBg={order.iconBg}
                  title={order.title}
                  content={order.content}
                />
              ))}
            </div>
            <div className="orders__right">
              <button type="button" onClick={shareLink}>
                <span>
                  <img src="/img/shareicon.svg" alt="shareicon" />
                </span>
                Share link
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="order__container">
        <div className="container">
          <div className="order__head">
            <ul>
              <li className={cn({ current__order: mainTab === "items" })}>
                <span onClick={() => setMainTab("items")}>
                  Select items for your order
                </span>
              </li>
              <li className={cn({ current__order: mainTab === "team" })}>
                <span onClick={() => setMainTab("team")}>
                  See what your team ordered <span>4</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="order__switcher--box">
          {mainTab === "items" ? (
            <div className="order__inner">
              <div className="container">
                <div className="order__main">
                  <div className="order__switcher">
                    <ul>
                      <li className={cn({ active__switcher: category === "all" })}>
                        <span onClick={() => setCategory("all")}>
                          All Items <span>{items.length}</span>
                        </span>
                      </li>
                      {CATEGORIES.map((name) => (
                        <li
                          key={name}
                          className={cn({ active__switcher: category === name })}
                        >
                          <span onClick={() => setCategory(name)}>
                            {name}
                            <span>
                              {
                                items.filter((item) => item.category === name)
                                  .length
                              }
                            </span>
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="order__box">
                    <div className="order__within">
                      <div className="budget-head">
                        <div className="budget-head__text">
                          <p>Within budget ($1.00 and under)</p>
                          <span>
                            100% covered by company subsidy — no out-of-pocket
                            cost
                          </span>
                        </div>
                        <span className="fully-covered-badge">
                          Fully Covered
                        </span>
                      </div>
                      <div className="order__within--container">
                        {withinBudget.map((item) => (
                          <SundayProductCard
                            key={item.id}
                            item={item}
                            onAdd={addItem}
                            onRemove={removeItem}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="order__outside">
                    <div className="budget-head">
                      <div className="budget-head__text">
                        <p>Outside of budget (Over $1.00)</p>
                        <span className="budget-sub--red">
                          Add these items to your order using your credit card.
                        </span>
                      </div>
                      <span className="split-payment-note">
                        Split payment at confirmation
                      </span>
                    </div>
                    <div className="order__outside--container">
                      {outsideBudget.map((item) => (
                        <SundayProductCard
                          key={item.id}
                          item={item}
                          onAdd={addItem}
                          onRemove={removeItem}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="team__container">
              <div className="container">
                <div className="head__order">
                  <h2>Here's what your team ordered (4)</h2>
                  <div className="filter__order">
                    <p>Filter:</p>
                    <input type="text" placeholder="Search by name" />
                  </div>
                </div>
                <div className="team__order--list">
                  <div className="user_not_found">
                    Team orders will appear here once members submit their
                    selections.
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <WidgetFooter />

      {showCheckout ? (
        <div
          className="checkout-modal__backdrop"
          onMouseDown={() => setShowCheckout(false)}
        >
          <div
            className="checkout-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="checkout-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <div className="checkout-modal__header">
              <div>
                <span>Sunday Team Lunch</span>
                <h2 id="checkout-title">Review your order</h2>
              </div>
              <button
                type="button"
                aria-label="Close checkout"
                onClick={() => setShowCheckout(false)}
              >
                ×
              </button>
            </div>
            {selectedItems.length ? (
              <div className="checkout-modal__items">
                {selectedItems.map((item) => (
                  <div className="checkout-item" key={item.id}>
                    <img src={item.img} alt={item.name} />
                    <div className="checkout-item__info">
                      <h3>{item.name}</h3>
                      <p>${item.price.toFixed(2)} each</p>
                    </div>
                    <div className="card-stepper">
                      <button type="button" onClick={() => removeItem(item.id)}>
                        −
                      </button>
                      <span>{item.qty}</span>
                      <button type="button" onClick={() => addItem(item.id)}>
                        +
                      </button>
                    </div>
                    <strong>${(item.price * item.qty).toFixed(2)}</strong>
                  </div>
                ))}
              </div>
            ) : (
              <div className="checkout-modal__empty">
                Your cart is empty. Add an item to continue.
              </div>
            )}
            <div className="checkout-modal__totals">
              <p>
                <span>Order subtotal</span>
                <strong>${total.toFixed(2)}</strong>
              </p>
              <p className="company">
                <span>Company portion</span>
                <strong>−${companyPortion.toFixed(2)}</strong>
              </p>
              <p className="checkout-total">
                <span>You pay today</span>
                <strong>${youPay.toFixed(2)}</strong>
              </p>
            </div>
            <div className="checkout-modal__actions">
              <button
                type="button"
                className="checkout-modal__clear"
                onClick={clearCart}
                disabled={!itemCount}
              >
                Clear cart
              </button>
              <button
                type="button"
                className="checkout-modal__submit"
                onClick={confirmOrder}
                disabled={!itemCount}
              >
                Checkout · ${youPay.toFixed(2)}
              </button>
            </div>
          </div>
        </div>
      ) : null}

      <div className="ordered__cart sunday-cart-bar">
        <div className="container">
          <div className="cart-bar">
            <div className="cart-bar__summary">
              <span className="cart-bar__icon" aria-hidden="true">
                🧾
              </span>
              <div className="cart-bar__info">
                <p className="cart-bar__title">
                  {itemCount} item{itemCount === 1 ? "" : "s"} Selected
                  <span>${total.toFixed(2)}</span>
                </p>
                <p className="cart-bar__subtitle">
                  Company portion ${companyPortion.toFixed(2)} • You pay today $
                  {youPay.toFixed(2)}
                </p>
              </div>
            </div>
            <div className="cart-bar__actions">
              <button
                className="cart-bar__clear"
                type="button"
                onClick={clearCart}
              >
                Clear
              </button>
              <button
                className="cart-bar__confirm"
                type="button"
                onClick={openCheckout}
              >
                <span role="img" aria-hidden="true">
                  🐼
                </span>{" "}
                Review &amp; Confirm Order
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(GroupOrder);
